import { render, staticRenderFns } from "./InputNumberDecimal.vue?vue&type=template&id=18b39454&"
import script from "./InputNumberDecimal.vue?vue&type=script&lang=js&"
export * from "./InputNumberDecimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports